module.exports = __webpack_public_path__ + "img/loca_shopping_bg.34a7236f.png";